<template lang="pug">
  div.wrap-module-search
    div.head.pt40.pb20
      div.f.fc
        div.wrap-img.mb40
          v-img(src="/img/hccc-logo.svg")
      div.search-area
        v-text-field(v-model="keyword" placeholder="カタリストを検索"
          outlined dark color="white" prepend-inner-icon="mdi-magnify")
    div.result.py30
      div.result-content
        ItemSearchResultList(v-for="user in resultUsers" :user="user")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-search {
  .head {
    background: $primary_bg_color;
    .search-area {
      margin: 0 auto;
      width: 300px;
      max-width: $base_max_width_px;
    }
  }
  .result {
    .result-content {
      margin: 0 auto;
      width: $base_width_percent;
      max-width: $base_max_width_px;
      border-top: $basic_border;
    }
  }
}
</style>

<style lang="scss">
// override vuetify style
.v-input__prepend-inner {
  margin-right: 6px;
}

</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import ItemSearchResultList from '@/components/item/ItemSearchResultList'

export default {
  components: {
    ItemSearchResultList
  },
  props: {
    users: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  watch: {
    keyword (keyword) {
      if (keyword === '') {
        this.resultUsers = this.users
      } else {
        this.resultUsers = this.users.filter(user => {
          const including = user.displayName.includes(keyword)
                          || user.profile.includes(keyword)
          return including
        })
      }
    }
  },
  data () {
    return {
      keyword: '',
      resultUsers: []
    }
  },
  created () {
    this.resultUsers = this.users
  }
}
</script>
